module.exports = __webpack_public_path__ + "img/invite.06fcf603.svg";